import { GlobalCallOptionsBuilder } from '../global-call-options';
import { QueueOpeningHoursSettingsBuilder, WaitOfferSettingsBuilder } from '.';
import { CallPriority } from '../call';
var QueueBuilder = /** @class */ (function () {
    function QueueBuilder() {
        this.queue = {
            id: 'b00b0b0b-b0b00b0b-0b0b0b0b0-0b0b0b0',
            name: 'bob queue',
            locale: 'en',
            default: false,
            totalAssignees: 3,
            description: '',
            creationDate: 1501145238000,
            lastUpdateDate: 1501145238000,
            callOptions: new GlobalCallOptionsBuilder().build(),
            useCallOptionsFromTenantSettings: true,
            queueOpeningHoursSettings: new QueueOpeningHoursSettingsBuilder().build(),
            queueWaitOfferSettings: new WaitOfferSettingsBuilder().build(),
            blockManualCallTransfer: false,
            queueCallPriority: CallPriority.NORMAL,
        };
    }
    QueueBuilder.prototype.withId = function (id) {
        this.queue.id = id;
        return this;
    };
    QueueBuilder.prototype.withName = function (name) {
        this.queue.name = name;
        return this;
    };
    QueueBuilder.prototype.withDescription = function (description) {
        this.queue.description = description;
        return this;
    };
    QueueBuilder.prototype.withLocale = function (locale) {
        this.queue.locale = locale;
        return this;
    };
    QueueBuilder.prototype.withCallPriority = function (callPriority) {
        this.queue.queueCallPriority = callPriority;
        return this;
    };
    QueueBuilder.prototype.withTotalAssignees = function (totalAssignees) {
        this.queue.totalAssignees = totalAssignees;
        return this;
    };
    QueueBuilder.prototype.withDefault = function (isDefault) {
        this.queue.default = isDefault;
        return this;
    };
    QueueBuilder.prototype.withCreationDate = function (date) {
        this.queue.creationDate = date;
        return this;
    };
    QueueBuilder.prototype.withLastUpdateDate = function (date) {
        this.queue.lastUpdateDate = date;
        return this;
    };
    QueueBuilder.prototype.withQueueWaitOfferSettings = function (queueWaitOfferSettings) {
        this.queue.queueWaitOfferSettings = queueWaitOfferSettings;
        return this;
    };
    QueueBuilder.prototype.withQueueOpeningHoursSettings = function (queueOpeningHoursSettings) {
        this.queue.queueOpeningHoursSettings = queueOpeningHoursSettings;
        return this;
    };
    QueueBuilder.prototype.withBlockManualCallTransfer = function (blockManualCallTransfer) {
        this.queue.blockManualCallTransfer = blockManualCallTransfer;
        return this;
    };
    QueueBuilder.prototype.withScheduleId = function (scheduleId) {
        this.queue.queueOpeningHoursSettings.schedule.scheduleId = scheduleId;
        return this;
    };
    QueueBuilder.prototype.build = function () {
        return this.queue;
    };
    return QueueBuilder;
}());
export { QueueBuilder };
//# sourceMappingURL=queue.builder.js.map